import { useState } from 'react';
import { Popover, Button, Grid } from '@mui/material';
import verticalicon from './../../../assets/home/newsfeed/verticalicon.png';

const EditPost = (props: any) => {
  const {setCounter, idd, setPostData, postData } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
 
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteHandler = (id:any) => {
    const filtered = postData.filter((obj: any) => obj.id !==id);
    setPostData(filtered)
    console.log(filtered); // [ 3, 4 ]
  }

  const openEditorHandler = () => {
    setCounter(2)
         console.log("edit handler run")
  }
  // console.log(showPostData)

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <>
      <Button aria-describedby={id} onClick={handleClick}>
        <img src={verticalicon} />
      </Button>
      <Popover
       className='remove-box-shadow'
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ 
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 8,
          horizontal: 77,
        }}
      >
        <div className='edit-post-box' >
          <Button onClick={openEditorHandler} sx={{ color: "black", display: "block", textTransform: "capitalize", p: 0, textAlign: "left" }} >
            Edit
          </Button>
          <Button sx={{ color: "black", display: "block", textTransform: "capitalize", p: 0, paddingTop: "10px", textAlign: "left" }} onClick={()=>deleteHandler(idd)} >
            Delete
          </Button>
        </div>

      </Popover>
    </>
    )
}

export default EditPost;